import React from 'react';
import { BInputError } from './index';

const BSelect = ({ name, isDirty = false, isHidden = false, label, icon: Icon, options = [], errors, ...props }) => {
  return (
    <div className={'flex w-full flex-col gap-1'} hidden={isHidden}>
      <p className={'text-sm font-normal text-slate-700'}>{label}</p>
      <div className={'relative'}>
        <div className={'pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3'}>
          {Icon && <Icon className={'size-4 text-slate-500'} />}
        </div>
      </div>
      <select
        name={name}
        hidden={isHidden}
        className={`w-full appearance-none py-3 ${Icon ? 'ps-8' : 'px-4'} focus:outline-primary-600 rounded-lg border border-slate-300 bg-slate-100 text-base leading-tight font-normal text-slate-600 placeholder-slate-400 focus:outline-2 ${isDirty ? 'italic' : 'normal'}`}
        {...props}
      >
        <option value={''}>Choisir...</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
      <BInputError errors={errors} />
    </div>
  );
};

export default BSelect;
